import { IModalidade } from "interfaces/eventos";
import { FormFieldConfig } from "interfaces/forms";

type Fields = keyof IModalidade;

const fieldFormModalidade: FormFieldConfig<Fields> = {
  id: {
    name: "id",
    label: "ID",
    type: "number",
  },
  icone: {
    name: "icone",
    label: "Icone",
    type: "text",
  },
  tipo: {
    name: "tipo",
    label: "Tipo",
    type: "text",
    errorMsg: "Tipo é obrigatório",
  },
};

export default fieldFormModalidade;
